export default "__VITE_ASSET__BWCHkxQT__"